import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import ProfileCreateUpdateComponent from '../../components/profiles/ProfileCreateUpdateComponent';
import { RootState } from '../../modules';
import { User, updateUserAsync, UserParams } from '../../modules/auth';
function ProfileEditContainer({ history }: RouteComponentProps) {
  const data = useSelector((state: RootState) => state.auth.auth.data);
  const dispatch = useDispatch();

  const onFinish = (user: User) => {
    const params: UserParams = {
      user,
    };
    dispatch(updateUserAsync.request(params));
    history.goBack();
  };
  const onCancel = () => {
    history.goBack();
  };
  return (
    <>
      {data && (
        <ProfileCreateUpdateComponent
          onFinish={onFinish}
          onCancel={onCancel}
          data={data}
        />
      )}
    </>
  );
}

export default ProfileEditContainer;
